import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class ValetIndoor extends AbstractProductType {

  name = 'valet_indoor'
  title = 'Valet Indoor'

  valet = true
  format = ProductTypeFormat.Indoor

}
